import React, { useRef } from 'react'
// import { Quote } from 'react-bootstrap-icons'
import { FaQuoteRight } from "react-icons/fa";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css'
import { useLanguage } from '../../contexts/LanguageContext';

const spanStyle = {
    padding: '20px',
    background: '#efefef',
    color: '#000000'
}

const divStyle = {
    display: 'grid',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    height: '420px',
    border:'1px solid #fe9b1f',
    marginRight:'1rem',
    marginLeft:'1rem',
    boxShadow:'2px 2px 10px 0px rgba(156.75, 105.53584484886358, 37.579534646739134, 0.5)',
}

// Testimonials data will be generated dynamically using translations

// Desktop settings
const desktopSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: false,
    autoplay: false,
    appendDots: (dots) => (
        <div style={{ marginTop: '580px', marginBottom: '-22px' }}>
            <ul style={{ 
                margin: '0', 
                padding: '0', 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center',
                gap: '0px' 
            }}>
                {dots}
            </ul>
        </div>
    ),
    customPaging: (i) => (
        <div 
            style={{
                width: '12px',
                height: '12px',
                backgroundColor: '#fe9b1f',
                borderRadius: '50%',
                opacity: 0.4,
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                margin: '0 4px'
            }} 
        />
    ),
    dotsClass: "slick-dots slick-thumb"
};

// Mobile settings
const mobileSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    appendDots: (dots) => (
        <div style={{ marginTop: '40px', marginBottom: '-10px' }}>
            <ul style={{ 
                margin: '0', 
                padding: '0', 
                display: 'flex',
                justifyContent: 'center', 
                alignItems: 'center',
                gap: '0px' 
            }}>
                {dots}
            </ul>
        </div>
    ),
    customPaging: (i) => (
        <div 
            style={{
                width: '12px',
                height: '12px',
                backgroundColor: '#fe9b1f',
                borderRadius: '50%',
                opacity: 0.4,
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                margin: '0 4px'
            }} 
        />
    ),
    dotsClass: "slick-dots slick-thumb"
};

const Testimonials = () => {
    const sliderRef = useRef(null);
    const { t } = useLanguage();

    // Generate slide images with translations
    const slideImages = [
        {
            url: 'home/EHR.webp',
            width:'75px',
            content: t('testimonials.ehr.content'),
            title: t('testimonials.ehr.company')
        },
        {
            url: 'home/Premier-Star-Logo-1.webp',
            width:'200px',
            content: t('testimonials.premierStar.content'),
            title: t('testimonials.premierStar.company')
        },
        {
            url: 'home/Premier-Builders-Logo-testimonial.webp',
            width:'80px',
            content: t('testimonials.premierBuilder.content'),
            title: t('testimonials.premierBuilder.company')
        },
        {
            url: 'home/GM-logo.webp',
            width:'220px',
            content: t('testimonials.ghulamMurtaza.content'),
            title: t('testimonials.ghulamMurtaza.company')
        },
    ];

    const handleDotClick = (index) => {
        if (sliderRef.current) {
            sliderRef.current.slickGoTo(index);
        }
    };

    return (
        <div id='website-responsive'>
            <style jsx>{`
                .slick-dots li.slick-active div {
                    opacity: 1 !important;
                    transform: scale(1.2);
                }
                .slick-dots li div:hover {
                    opacity: 0.8 !important;
                }
            `}</style>
            <div className='left-padding8rem1 right-padding8rem1 py-md-5 py-4'>
                <div className='pb-md-4 pb-3' style={{ color: '#FE9B1F' }}>
                    <center>
                        <h3 className='fs-ss-38 text-philos fw-700 text-ss-primary'>
                            {t('testimonials.title')}
                        </h3>
                    </center>
                </div>

                <div className=''>
                    {/* Desktop Testimonials */}
                    <div className="slide-container d-none d-md-block">
                        <Slider {...desktopSettings}>
                            {slideImages.map((slideImage, index) => (
                                <div key={index} className='pb-5'>
                                    <div className='rounded10 p-md-4 p-3' style={{ ...divStyle }}>
                                        <div className=''>
                                            <FaQuoteRight className='fs-ss-52 text-ss-primary fw-800'/>
                                        </div>
                                        <center>
                                        <div className=''>
                                            <img src={slideImage.url} alt='' width={slideImage.width}  />
                                        </div>

                                        <div className='pxmd-3 my-3 my-md-4'>
                                            <p className='fs-ss-16 text-mulish fw-500'>
                                                {slideImage.content}
                                            </p>
                                        </div>

                                        <div className='mt-3' style={{ width:'10%', borderTop:'2px solid #fe9b1f' , color:'#fe9b1f'}} />

                                        <div className=' pt-md-4'>
                                        <p className='text-ss-primary text-philos fs-ss-20 fw-700'>
                                                {slideImage.title}
                                            </p>
                                        </div>
                                        </center>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>

                    {/* Mobile Testimonials */}
                    <div className="slide-container d-block d-md-none">
                        <Slider {...mobileSettings}>
                            {slideImages.map((slideImage, index) => (
                                <div key={index} className=''>
                                    <div className='rounded10 p-3' style={{ ...divStyle, height: 'auto', minHeight: '300px', margin: '0 0.5rem' }}>
                                        <div className=''>
                                            <FaQuoteRight className='fs-ss-40 text-ss-primary fw-800'/>
                                        </div>
                                        <center>
                                        <div className=''>
                                            <img src={slideImage.url} alt='' width={slideImage.width}  />
                                        </div>

                                        <div className='px-2 my-3'>
                                            <p className='fs-ss-14 text-mulish fw-500' style={{ lineHeight: '1.4' }}>
                                                {slideImage.content}
                                            </p>
                                        </div>

                                        <div className='mt-3' style={{ width:'15%', borderTop:'2px solid #fe9b1f' , color:'#fe9b1f'}} />

                                        <div className='pt-3'>
                                        <p className='text-ss-primary text-philos fs-ss-18 fw-700'>
                                                {slideImage.title}
                                            </p>
                                        </div>
                                        </center>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Testimonials